import callApi from '@/utils/callApi';
import { memoize } from '@gamifiera/array-cache';
import mergeDeep from '@/utils/mergeDeep';

const getMerchantConfig = memoize(async function () {
  const res = await callApi('GET', '/v1/merchant-config');

  if (res.status !== 200) {
    throw new Error('Could not load merchant config');
  }

  let config = await res.json();

  const merchantConfigPreview = window.gmf_preview_config;
  if (merchantConfigPreview) {
    config = mergeDeep(config, merchantConfigPreview);
  }

  return config;
}, 600);

// If we already have the merchant config on the window object, let's prefill the cache
if (window.gmf_config.merchantConfig) {
  getMerchantConfig.hydrate([], window.gmf_config.merchantConfig);
}

export default getMerchantConfig;
